import React from "react";

import * as S from "./styled";

const SuggestSignup = () => {
  const triggerNode = <S.StyledTooltipIcon />;
  return (
    <S.Wrapper>
      <S.Text>Simplify tracking your open houses when you sign up.</S.Text>
      <S.StyledTooltip
        position="bottom"
        theme="small"
        triggerNode={triggerNode}
        width="auto"
        zIndex={999}
      >
        <S.TooltipContent>
          When you sign up, your personal info isn&#39;t shared with agents.
          They only see number of guests.
        </S.TooltipContent>
      </S.StyledTooltip>
    </S.Wrapper>
  );
};

export default SuggestSignup;
